<template>
  <SwiperSlider
    ref="swiper"
    :options="swiperOptions"
    :class="['categoryBrands', { 'categoryBrands--popup': isPopup }]"
  >
    <div v-for="(item, index) in brands" :key="index" class="categoryBrands__slide swiper-slide">
      <nuxt-link
        :to="
          localePath({
            name: 'brand-slug',
            params: {
              slug: item.slug,
            },
          })
        "
        class="categoryBrands__slideLink"
      >
        <new-image-box
          :alt="item.name"
          background-color="#fff"
          :src="item.logoUrl100x80"
          :width="100"
          :height="60"
          image-params="w_100,h_60"
        />
      </nuxt-link>
    </div>
  </SwiperSlider>
</template>

<script>
import NewImageBox from '@/components/NewImageBox';
import SwiperSlider from '~/components/SwiperSlider';

export default {
  name: 'CategoryBrands',
  components: {
    SwiperSlider,
    NewImageBox,
  },
  props: {
    brands: {
      type: Array,
      default: null,
    },
    isPopup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      swiperOptions: {
        init: true,
        slidesPerView: 7,
        loop: this.brands.length > 5,
        speed: 900,
        spaceBetween: 0,
        autoplay: {
          delay: 1500,
        },
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 5,
        },
      },
    };
  },
};
</script>

<style lang="scss">
.categoryBrands {
  $root: &;

  &--popup {
    width: 760px;
  }

  &__slide {
    display: flex;
    align-items: center;
    justify-content: center;
    height: auto;
    padding: 0 15px;
  }

  &__slideLink {
    width: 100%;
    display: block;
  }
}
</style>
